import { FileSchema } from './common';
import { repeat, unreachable } from '../util';
import { number, z, ZodSchema, type ZodErrorMap } from 'zod';
import type { IGameState, IStage } from '.';

export const vingerAfdrukkenPlayerColors = ['blue', 'green', 'yellow', 'orange'];

export const VingerAfdrukkenDataSchema = z.object({}).default({});

export type Stage = IStage | 'answer-questions' | 'wait-for-rounds' | 'play-rounds' | 'wait-for-swipe' | 'play-swipe-card';

export type VingerAfdrukZone = 'I' | 'M' | 'P' | 'V';

export const VingerAfdrukScheme = z.object({
	number: z.number(),
	points: z.number(),
	questions: z.array(z.number()),
});
export type VingerAfdruk = z.infer<typeof VingerAfdrukScheme>;

export const CardScheme = z.object({
	playerIndex: z.number(),
	questionNumber: z.number(),
	microvezelPower: z.boolean().optional(),
	answer: z.string().optional(),
	question: z.string(),
});
export type Card = z.infer<typeof CardScheme>;

export type VingerAfdrukQuestion = {
	text: string;
	number: number;
	zone: VingerAfdrukZone;
	answer?: string;
	locked?: boolean;
	capturable?: boolean;
};

export type VingerAfdrukkenTeamData = {
	vingerafdruk: [VingerAfdruk, VingerAfdruk, VingerAfdruk];
};

export const VingerAfdrukkenThemeSchema = z.object({
	name: z.string(),
});
export type VingerAfdrukkenTheme = z.infer<typeof VingerAfdrukkenThemeSchema>;

export const VingerAfdrukkenPresetSchema = z.object({
	presetName: z.string().default('No name'),
	theme1: VingerAfdrukkenThemeSchema.default({ name: '' }),
	theme2: VingerAfdrukkenThemeSchema.default({ name: '' }),
	theme3: VingerAfdrukkenThemeSchema.default({ name: '' }),
	theme4: VingerAfdrukkenThemeSchema.default({ name: '' }),
	customQuestions: z.record(z.string(), z.string()).default({}),
});
export type VingerAfdrukkenPreset = z.infer<typeof VingerAfdrukkenPresetSchema>;

export const defaultQuestionsData: VingerAfdrukQuestion[] = [
	{ zone: 'I', number: 1, text: '$I: Bedenk een concrete actie. Wat gaan we doen of organiseren om dit thema een boost te geven?' },
	{ zone: 'P', number: 2, text: "$P: Bedenk een concrete actie. Welke actie kunnen jullie morgen doorzetten waardoor je collega's het verschil gaan merken?" },
	{ zone: 'V', number: 3, text: '$V: Bedenk een concrete actie. Welke concrete stap gaan jullie zetten om dit thema een (nieuw) leven in te blazen?' },
	{ zone: 'M', number: 4, text: '$M: Bedenk een concrete actie. Wat is de eerste actie die jullie morgen meteen kunnen uitproberen om dit thema een boost te geven?' },
	{ zone: 'I', number: 5, text: '$I: Bedenk een concrete actie. Wat gaan we doen of organiseren om de uitrol van dit thema te versnellen?' },
	{ zone: 'M', number: 6, text: '$M: Bedenk een concrete actie. Wat wordt jullie allereerste experiment om dit thema een zichtbaar te maken? ' },
	{ zone: 'P', number: 7, text: '$P: Bedenk een concrete actie. Stel dat jullie morgen een vliegende start maken, wat hoort daar absoluut bij waardoor dit thema meer gaat leven?' },
	{ zone: 'V', number: 8, text: '$V: Bedenk een concrete actie. Wat gaan jullie doen om dit thema te versterken met extra energie? Hoe ziet dit in de praktijk eruit?' },
	{ zone: 'M', number: 9, text: '$M: Bedenk een concrete actie. Wat ga je morgen meteen anders aanpakken? Hoe ga je dit thema aanjagen?' },
	{ zone: 'I', number: 10, text: '$I: Bedenk een concrete actie. Hoe ziet het morgen eruit als jullie dit écht serieus nemen?' },
	{ zone: 'V', number: 11, text: '$V: Bedenk een concrete actie. Welke concrete stap gaan jullie zetten om dit thema een (nieuw) leven in te blazen?' },
	{ zone: 'I', number: 12, text: '$I: Bedenk een concrete actie. Wat gaan we doen of organiseren om de uitrol van dit thema te versnellen?' },
	{ zone: 'M', number: 13, text: '$M: Bedenk een concrete actie. Wat is de eerste actie die jullie morgen meteen kunnen uitproberen om dit thema te versterken?' },
	{ zone: 'P', number: 14, text: '$P: Bedenk een concrete actie. Wat wordt jullie allereerste experiment om dit thema een zichtbaar te maken?' },
	{ zone: 'I', number: 15, text: '$I: Bedenk een concrete actie. Hoe ziet het morgen eruit als jullie dit écht serieus nemen?' },
	{ zone: 'M', number: 16, text: '$M: Bedenk een concrete actie. Wat wordt jullie allereerste experiment om dit thema een zichtbaar te maken?' },
	{ zone: 'P', number: 17, text: '$P: Bedenk een concrete actie. Stel dat jullie morgen een vliegende start maken, wat hoort daar absoluut bij waardoor dit thema meer gaat leven?' },
	{ zone: 'V', number: 18, text: '$V: Bedenk een concrete actie. Wat gaan jullie doen om dit thema te versterken met extra energie? Hoe ziet dit in de praktijk eruit?' },
	{ zone: 'M', number: 19, text: '$M: Bedenk een concrete actie. Wat wordt jullie allereerste experiment om dit thema een zichtbaar te maken?' },
	{ zone: 'P', number: 20, text: "$P: Bedenk een concrete actie. Welke actie kunnen jullie morgen doorzetten waardoor je collega's het verschil gaan merken?" },
	{ zone: 'V', number: 21, text: '$V: Bedenk een concrete actie. Wat gaan jullie doen om dit thema te versterken met extra energie? Hoe ziet dit in de praktijk eruit?' },
	{ zone: 'M', number: 22, text: '$M: Bedenk een concrete actie. Wat ga je morgen meteen anders aanpakken? Hoe ga je dit thema aanjagen?' },
	{ zone: 'P', number: 23, text: "$P: Bedenk een concrete actie. Welke actie kunnen jullie morgen doorzetten waardoor je collega's het verschil gaan merken? " },
	{ zone: 'I', number: 24, text: '$I: Bedenk een concrete actie. Wat gaan we doen of organiseren om dit thema een boost te geven?' },
	{ zone: 'V', number: 25, text: '$V: Bedenk een concrete actie. Welke concrete stap gaan jullie zetten om dit thema een (nieuw) leven in te blazen?' },
];

export type VingerAfdrukkenAnswer = { questionNumber: number; answer: string };
export type VingerAfdrukkenPlayerState = {
	id: string;
	name: string;
	color: string;
	score: number;
	active: boolean;
	lastScreen: VingerAfdrukkenUpdate;
	answers: VingerAfdrukkenAnswer[];
	selectedCards: number[];
	finishedSwipeCards: boolean;
};

export type VingerAfdrukkenState = {
	stage: Stage;
	roundIndex: number;
	lastRound: boolean;
	players: VingerAfdrukkenPlayerState[];
	currentPlayerIndex: number;
	game: VingerAfdrukkenPreset;
	answersOnBoard: { questionNumber: number; playerIndex: number; microvezelPower?: boolean }[];
};

export const VingerAfdrukkenClientSchema = z.array(
	z.object({
		number: z.number(),
		points: z.number(),
		questions: z.array(
			z.object({
				number: z.number(),
				text: z.string(),
				answer: z.string().optional(),
				locked: z.boolean().optional(),
				capturable: z.boolean().optional(),
			}),
		),
	}),
);
export type VingerAfdrukkenClient = z.infer<typeof VingerAfdrukkenClientSchema>;

export const VingerAfdrukkenUpdateSchema = z.discriminatedUnion('kind', [
	z.object({ kind: z.literal('trigger-effect'), effect: z.enum(['confetti', 'red-flash']), text: z.string().optional() }),
	z.object({
		kind: z.literal('show-vinger-afdruk-completed'),
		vingerAfdruk: VingerAfdrukScheme,
		type: z.enum(['completed', 'stolen']),
	}),
	z.object({ kind: z.literal('show-login-screen'), failed: z.boolean().optional() }),
	z.object({ kind: z.literal('show-register-screen') }),
	z.object({
		kind: z.literal('show-questions-screen'),
		vingerafdrukken: VingerAfdrukkenClientSchema,
		timerFrom: z.number(),
		timerTo: z.number(),
	}),
	z.object({
		kind: z.literal('show-wait-screen'),
		title: z.string(),
		message: z.string(),
	}),
	z.object({
		kind: z.literal('show-wait-screen-and-question-screen'),
		title: z.string(),
		message: z.string(),
		vingerafdrukken: VingerAfdrukkenClientSchema,
	}),

	z.object({
		kind: z.literal('show-choose-diceroll-screen'),
	}),
	z.object({
		kind: z.literal('show-choose-question-screen'),
		vingerafdrukken: VingerAfdrukkenClientSchema,
		microvezelPower: z.boolean(),
	}),
	z.object({
		kind: z.literal('show-swipecards-screen'),
		cards: z.array(CardScheme),
	}),
	z.object({
		kind: z.literal('show-present-answer-screen'),
		number: z.number(),
		question: z.string(),
		answer: z.string(),
	}),
	z.object({
		kind: z.literal('show-results-screen'),
		players: z.array(z.object({ name: z.string(), color: z.string(), score: z.number() })),
		reportUrl: z.string(),
	}),

	z.object({
		kind: z.literal('update-players-state'),
		players: z.array(z.object({ name: z.string(), color: z.string() })),
	}),
	z.object({
		kind: z.literal('update-player-state'),
		player: z.object({
			name: z.string(),
			color: z.string(),
			score: z.number(),
			answers: z.array(
				z.object({
					questionNumber: z.number(),
					answer: z.string(),
				}),
			),
		}),
	}),
]);
export type VingerAfdrukkenUpdate = z.infer<typeof VingerAfdrukkenUpdateSchema>;

export const VingerAfdrukkenMessageSchema = z.discriminatedUnion('kind', [
	// TODO: make it so this can only be sent by admin
	z.object({ kind: z.literal('start-game') }),
	z.object({ kind: z.literal('end-questions') }),
	z.object({ kind: z.literal('start-rounds') }),
	z.object({ kind: z.literal('set-is-last-round'), lastRound: z.boolean() }),
	z.object({ kind: z.literal('force-restart-round') }),
	z.object({ kind: z.literal('set-player-active'), playerId: z.string(), active: z.boolean() }),
	z.object({ kind: z.literal('finish-presenting') }),

	z.object({ kind: z.literal('update-player-data'), playerId: z.string(), name: z.string(), color: z.string() }),
	z.object({ kind: z.literal('remove-player-data'), playerId: z.string() }),
	z.object({ kind: z.literal('submit-answer'), playerId: z.string(), questionNumber: z.number(), answer: z.string() }),
	z.object({ kind: z.literal('submit-diceroll'), playerId: z.string(), diceroll: z.number() }),
	z.object({ kind: z.literal('submit-answer-to-present'), playerId: z.string(), questionNumber: z.number() }),
	z.object({ kind: z.literal('choose-cards'), playerId: z.string(), cards: z.array(z.number()) }),
	z.object({ kind: z.literal('start-swipe-cards') }),
	z.object({ kind: z.literal('start-ending-report') }),
]);

export type VingerAfdrukkenMessage = z.infer<typeof VingerAfdrukkenMessageSchema>;
